// getGameCatalogueFeedItem.ts

import type { z } from "zod";
import type { FeedItemSchema } from "@bridge-applications/eh-types";

export const GAME_CATALOGUE_FEED_ITEM_ID =
    "e5c5e223-5b57-4c8c-a9cf-321c9891d630";

const GAME_CATALOGUE_LINK = {
    type: "INTERNAL_ROUTE",
    path: "/game-catalogue",
} as const;

export function getGameCatalogueFeedItem(): z.infer<typeof FeedItemSchema> {
    return {
        productType: "GENERIC_LINK",
        category: "GENERIC",
        itemId: GAME_CATALOGUE_FEED_ITEM_ID,
        uid: "generic_link:game-catalogue",
        title: {
            en: "Discover Trending Games",
            es: "Descubre juegos en tendencia",
            "pt-br": "Descubra jogos em alta",
            id: "Temukan game yang sedang tren",
            th: "ค้นพบเกมยอดนิยม",
        },
        subtitle: {
            en: "Weekly refreshed",
            es: "Actualizado semanalmente",
            "pt-br": "Atualizado semanalmente",
            id: "Diperbarui setiap minggu",
            th: "อัปเดตทุกสัปดาห์",
        },
        thumbnailUrl:
            "https://media.bridge.cm/trending-apps-thumbnail_e5c5e223-5b57-4c8c-a9cf-321c9891d630.webp",
        link: GAME_CATALOGUE_LINK,
        raw: {
            id: "game-catalogue",
            link: GAME_CATALOGUE_LINK,
        },
        relation: null,
        listingToken: undefined,
    };
}
